import React from 'react';
import { observer } from 'mobx-react-lite';
import { roundsWinBetTypes } from '../../store/roundsWinBetTypes';
import StatisticListWr from '../../components/statistics/statisticListWr';
import { WinMarketsCountMobile } from '../../components/statistics/winMarketsCountMobile';
import StatisticListMobile from '../../components/statistics/statisticListMobile';
import GameResultsMobile from '../../components/statistics/gameResultsMobile';

export const StatisticsMobile = observer(() => {
  const { winBetTypes } = roundsWinBetTypes;

  return (
    <StatisticListWr
      isMobile
      winBetTypes={winBetTypes}
      ResultListComp={GameResultsMobile}
      WinMarketsComp={WinMarketsCountMobile}
      StatisticListComp={StatisticListMobile}
    />
  );
});
